import { Icon } from 'assets/Icon.js';
import { ConfirmModal } from 'components/ui/modals/ConfirmModal/index.js';

import { getHelpdeskDialogActions } from './Helpdesk.actions.js';
import { useHelpdeskEffects } from './Helpdesk.effects.js';
import {
  getHelpdeskModalIcon,
  HelpdeskModalContent,
} from './Helpdesk.sections.js';
import { StyledIconButton } from './Helpdesk.styled.js';

export const Helpdesk = () => {
  const {
    modalId,
    isHelpdeskModalOpen,
    onHelpdeskButtonClick,
    onCloseHelpdeskModal,
    modalState,
    errorMessage,
    onCreateTicket,
  } = useHelpdeskEffects();

  return (
    <>
      <StyledIconButton
        aria-label="Open helpdesk"
        role="button"
        onClick={onHelpdeskButtonClick}
      >
        <Icon icon="helpOutlineRoundedSvg" sx={{ height: 25, width: 25 }} />
      </StyledIconButton>
      <ConfirmModal
        id={modalId}
        open={isHelpdeskModalOpen}
        onClose={onCloseHelpdeskModal}
        Icon={getHelpdeskModalIcon(modalState)}
        actions={getHelpdeskDialogActions({
          state: modalState,
          onClose: onCloseHelpdeskModal,
        })}
      >
        <HelpdeskModalContent
          state={modalState}
          errorMessage={errorMessage}
          onSubmit={onCreateTicket}
        />
      </ConfirmModal>
    </>
  );
};
